/**
 * @name EmployeesGraph
 * @description Componente que muestra la grafica de colaboradores hombres y mujeres
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Card, Theme, Typography } from '@styles';
import { DonutChart } from '@styles/apex-charts';

const EmployeesGraph = (props) => {
  const { man, woman } = props;

  return (
    <>
      {/* HEADER */}
      <Card.Header divider>
        <Card.HeaderTitle>
          <Typography.H5>{i18n.t('GenericMessages.employees')}</Typography.H5>
          <Typography.Text color="greyDarkAlpha">{i18n.t('Home.genderDemographics')}</Typography.Text>
        </Card.HeaderTitle>
      </Card.Header>

      <Card.Content scroll>
        <BoxGraph>
          <DonutChart
            colors={[Theme.colors.purple, Theme.colors.blueDark]}
            labels={[i18n.t('Home.woman'), i18n.t('Home.man')]}
            series={[woman, man]}
            totalLabel={i18n.t('GenericMessages.employees')}
            height={225}
          />
        </BoxGraph>
      </Card.Content>
    </>
  );
};

EmployeesGraph.propTypes = {
  // Número de empleados hombres en la empresa.
  man: PropTypes.number.isRequired,
  // Número de empleados mujeres en la empresa.
  woman: PropTypes.number.isRequired,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const BoxGraph = styled.div`
  display: block;
  height: 100%;
  padding: 8px;
`;

export default EmployeesGraph;